"use client"

import Image from "next/image"
import { ThemeToggle } from "../ThemeToggle"
import { NavigationBar } from "../NavigationBar"
import { PwaInstallButton } from "../PwaInstallButton"

export const MyHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-800 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2 group" suppressHydrationWarning>
          <Image
            src={"/images/my-brand.png"}
            alt="Amit Dhoju logo"
            width={48}
            height={48}
            priority
            className="rounded-full transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-teal-500/50"
          />
          <span className="text-lg font-semibold transition-colors duration-300 group-hover:text-teal-600 dark:group-hover:text-teal-400">
            Amit Dhoju
          </span>
        </div>
        <div className="flex items-center gap-2 md:hidden">
          <PwaInstallButton />
          <ThemeToggle />
          <NavigationBar />
        </div>
        <div className="hidden md:flex items-center gap-4">
          <NavigationBar />
          <PwaInstallButton />
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}
